// extracted by mini-css-extract-plugin
export default {"stars":"Stars_stars__UE8rJ","active":"Stars_active__zSfGT"};